module.exports = __webpack_public_path__ + "d0c56ca4f5e93e8b10e010e49b840620.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-13.png
// module id = 1967
// module chunks = 0